export default __webpack_public_path__ + "static/media/Punto_12_Finocchietti_SPA_Def.7f9616a3.aac";